import { Controller } from "stimulus"
import {DataTable} from "simple-datatables"

export default class extends Controller {
  static targets = ["phone", "email"]

  initialize() {
    this.dataTable = new DataTable("#contactListTable", {
      perPage: 20,
      perPageSelect: false,
      labels: {
        noRows: "No contacts found",
        info: "Showing {start} to {end} of {rows} contacts"
      }
    });
    this.ourSearchBar = document.getElementById('contactSearchBar');
    this.simpleDatatableSearch = document.getElementsByClassName('dataTable-input')[0];
    this.setupDataTableSearch();
    this.addDeleteModalEventListener();
    this.focusOnDeleteModal();
    this.addSortButtonLabels();
    this.addPaginationLabels();
  }

  addSortButtonLabels() {
    //for screenreaders to announce the sort column
    let sortLinks = document.querySelectorAll('.dataTable-sorter');
    sortLinks.forEach((link, index) => {
      link.setAttribute('aria-label', `Sort column ${index + 1}`);
    });
  }

  addPaginationLabels() {
    //for screenreaders to announce the page number in the table
    let paginationLinks = document.querySelectorAll('.dataTable-pagination a');
    paginationLinks.forEach((link, index) => {
      link.setAttribute('aria-label', `Go to page ${index + 1}`);
    });
  }

  addDeleteModalEventListener() {
    let deleteContactModal = document.getElementById('deleteContactModal');
    deleteContactModal.addEventListener('shown.bs.modal', function (event) {
      let button = event.relatedTarget
      let contactData = button.getAttribute('data-bs-delete-contact')
      let data = JSON.parse(contactData);
      document.getElementById('deleteContactHeader').innerHTML = 'Delete ' + data.name + '?'
      document.getElementById('deleteContactForm').action = 'contacts/' + data.id.toString();
    })
  }

  focusOnDeleteModal() {
    //focuses on modal when it is shown
    //required for screen readers
    var modal = document.getElementById('deleteContactModal');
    modal.addEventListener('shown.bs.modal', function() {
      var firstInput = document.getElementById('confirmDelete');

      if (firstInput) {

          firstInput.focus();
      }
  });
  }

  setupDataTableSearch(){
    this.ourSearchBar.addEventListener('keyup', (e) => {
      this.simpleDatatableSearch.value = this.ourSearchBar.value;
      this.simpleDatatableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }



}